import { createFileRoute } from '@tanstack/react-router';

import { creditNoteDetailSearch } from '@/modules/credit-note/public';
import { lazyScreen } from '@/shared/screen';

// O testing.ts (com o msw) só por import() no ramo de DEV: estático, ele entrava no JS inicial de produção.
export const Route = createFileRoute('/dev/credito/$creditNoteId')({
  validateSearch: creditNoteDetailSearch,
  component: import.meta.env.DEV ? lazyScreen(async () => (await import('@/modules/credit-note/testing')).loadCreditNoteDetailScreen(), 'CreditNoteDetailScreen') : () => null,
});
